import styled from '@emotion/styled';

export const PageSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
`;
